import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@design-system/box';
import { separatorShadow } from '@design-system/theme';
import { useRef } from 'react';
import { styled } from 'styled-components';
import { useProperty } from '../hooks/useProperty';
export const Footer = (_a) => {
    var { children, isLoading, parentId, property = 'modal-foot' } = _a, props = __rest(_a, ["children", "isLoading", "parentId", "property"]);
    const ref = useRef(null);
    useProperty(ref, 'dialog', parentId, property);
    return (_jsx(FooterStyled, Object.assign({ "$isLoading": isLoading }, props, { ref: ref, children: children })));
};
const FooterStyled = styled(Box).attrs(({ $isLoading, children, height = 'min-content', justifyContent = 'flex-end', p = 6, }) => ({
    display: children && !$isLoading ? 'flex' : 'none',
    height,
    justifyContent,
    p,
})) `
  grid-area: modal-foot;
  ${({ $withShadow }) => $withShadow && separatorShadow}
`;
//# sourceMappingURL=Footer.js.map